import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminClasses() {
  const [classes, setClasses] = useState([]);
  const [form, setForm] = useState({ name:'', description:'', capacity:20, duration_mins:60, schedule_day:'monday', schedule_time:'09:00', room:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const load = () => axios.get('/member/classes').then(r => setClasses(r.data));
  useEffect(() => { load(); }, []);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      await axios.post('/trainer/classes', form);
      setMsg('Class created!'); load();
    } catch { setMsg('Error.'); } finally { setSaving(false); }
  };

  const days = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];

  return (
    <div>
      <div className="page-header"><div><h1 className="page-title">Group classes</h1><p className="page-sub">Manage class schedule</p></div></div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:18 }}>
        <div className="card">
          <div className="card-header"><div className="card-title">📅 Class schedule</div></div>
          {classes.length === 0 ? <div className="empty-state"><p>No classes yet.</p></div> : (
            <table className="table">
              <thead><tr><th>Class</th><th>Day</th><th>Time</th><th>Capacity</th><th>Booked</th></tr></thead>
              <tbody>
                {classes.map(c => (
                  <tr key={c.id}>
                    <td><div className="name">{c.name}</div><div style={{ fontSize:11, color:'var(--text-muted)' }}>{c.trainer_name}</div></td>
                    <td style={{ textTransform:'capitalize' }}>{c.schedule_day}</td>
                    <td>{c.schedule_time?.slice(0,5)}</td>
                    <td>{c.capacity}</td>
                    <td><span className="badge badge-accent">{c.bookings_count}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">➕ Add class</div></div>
          <form onSubmit={handleSave} style={{ padding:20 }}>
            {msg && <div style={{ marginBottom:12, padding:'9px 14px', borderRadius:'var(--radius)', background:'var(--success-dim)', color:'var(--success)', fontSize:13 }}>{msg}</div>}
            <div className="form-group"><label className="label">Class name *</label><input className="input" value={form.name} onChange={e => setForm(p=>({...p,name:e.target.value}))} required /></div>
            <div className="form-row">
              <div className="form-group"><label className="label">Day *</label>
                <select className="select" value={form.schedule_day} onChange={e => setForm(p=>({...p,schedule_day:e.target.value}))}>
                  {days.map(d => <option key={d} value={d} style={{ textTransform:'capitalize' }}>{d.charAt(0).toUpperCase()+d.slice(1)}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="label">Time *</label><input className="input" type="time" value={form.schedule_time} onChange={e => setForm(p=>({...p,schedule_time:e.target.value}))} required /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label className="label">Capacity</label><input className="input" type="number" value={form.capacity} onChange={e => setForm(p=>({...p,capacity:e.target.value}))} /></div>
              <div className="form-group"><label className="label">Duration (min)</label><input className="input" type="number" value={form.duration_mins} onChange={e => setForm(p=>({...p,duration_mins:e.target.value}))} /></div>
            </div>
            <div className="form-group"><label className="label">Room / location</label><input className="input" placeholder="e.g. Studio A" value={form.room} onChange={e => setForm(p=>({...p,room:e.target.value}))} /></div>
            <button className="btn-primary" type="submit" disabled={saving} style={{ width:'100%', justifyContent:'center' }}>{saving ? 'Saving…' : 'Create class'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
